module.exports = __webpack_public_path__ + "static/img/1-1.137a5b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/1-1.png
// module id = TDA7
// module chunks = 0